import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import useFetchData from "../../../../hooks/useFetchData";
import { Link } from "react-router-dom";
import { Previous } from "../../../../components/Icons/Icons";
import FormAdd from "../AddRole/FormAdd";
import ListRoleSelect from "../ListRole/ListRoleSelect";
import { role } from "../../../../services/api/RoleApi";
import styles from "./EditRole.module.css";
import { Loading, Toast } from "../../../../components";

const cx = classNames.bind(styles);
const AddRole = () => {
  const navigate = useNavigate();
  const prams = useParams();
  const [loading, setLoading] = useState(false)
  const [newRole, setNewRole] = useState({
    subject_name: "",
    note: "",
  });
  const [listRole, setListRole] = useState([]);

  const handleAddRole = () => {
    setLoading(!loading)
    const code = prams.id
    async function addRole() {
      const listData = listRole.map(item => {
        return {
          ...item,
          NOTE: newRole.note
        }
      })
      try {
        if (newRole.subject_name && newRole.subject_name !== "") {
          const data = {
            ...newRole,
            company_code: sessionStorage.getItem("company_code"),
            list_permissions: {
              data: listData,
            },
          };
          const res = await role.updateRole(JSON.stringify(data), code);
          setLoading(false)
          if (res) {
            Toast.open("Sửa quyền thành công", "success");
            navigate("/admin/role");
          }
        }
        else {
          Toast.open("Tên quyền không được để trống", "danger")
          setLoading(false)
        }
      } catch (e) {
        setLoading(false)
        if (e.response.data.mess && e?.response?.status !== 500) {
          Toast.open(e.response.data.mess, "danger");
        } else if(e?.response?.status === 500 && listRole.length === 0) {
          Toast.open("Bạn chưa chọn chức năng", "danger");
        } else {
          Toast.open("Sửa quyền không thành công", "danger");
        }
      }
    }
    addRole();
  };
  const listPermission = useFetchData("/permission/get-list-permission/", {
    usertype_code: prams.id,
  }, "chỉnh sửa");
  useEffect(() => {
    async function listRoleSelect() {
      const data = listPermission?.data?.map((item) => {
        return {
          PERMISSION_TYPE_CODE: item.PERMISSION_TYPE_CODE,
          USER_FUNCTION_CODE: item.USER_FUNCTION_CODE,
          NOTE: item.NOTE,
        };
      });
      setListRole(data);
      setNewRole({ subject_name: listPermission?.data[0]?.TYPE_NAME, note: listPermission?.data[0]?.NOTE })
    }
    listRoleSelect();
  }, [listPermission.data]);
  return (
    <>
      <div className={cx("container")}>
        <div className={cx("header")}>
          <Link style={{ textDecoration: "none" }} to="/admin/role">
            <span className={cx("icon")}>
              <Previous />
            </span>
          </Link>
          <h1 className={cx("title")}>Chỉnh sửa quyền</h1>
        </div>
        <div className={cx("content")}>
          <div className={cx("item_add")}>
            <FormAdd
              newRole={newRole}
              setNewRole={setNewRole}
            />
          </div>
          <div className={cx("item-user")}>
            <ListRoleSelect
              role={listRole}
              setRole={setListRole}
              title={"Danh sách chức năng"}
              type="Thêm"
              userType={prams.id}
              listPermission={listPermission}
            />
          </div>
        </div>
        <div className={cx("footer")}>
          <button onClick={handleAddRole} className={cx("btn-add")}>
            Xác nhận
          </button>
          <button className={cx("btn-cancel")} onClick={() => navigate(-1)}>Hủy bỏ</button>
        </div>
      </div>
      {loading && (
        <div className={cx('loading-container')}>
          <Loading />
        </div>
      )}
    </>
  );
};

export default AddRole;
